/*
  blog-influx.js  -  shared behaviour for the Learning blog
  Table-of-contents scrollspy + mobile collapse. Per-article widget JS lives
  inline in each snippets/blog-*.liquid.
*/
/* TABLE OF CONTENTS: scrollspy + mobile collapse */
(function(){
  "use strict";
  var toc=document.getElementById("toc");if(!toc)return;
  function syncOpen(){if(window.matchMedia("(min-width:1024px)").matches){toc.setAttribute("open","");}}
  syncOpen();window.addEventListener("resize",syncOpen,{passive:true});
  var links=Array.prototype.slice.call(toc.querySelectorAll("a[href^='#']"));
  var map=links.map(function(a){return {a:a,el:document.getElementById(a.getAttribute("href").slice(1))};}).filter(function(x){return x.el;});
  var OFFSET=120,ticking=false;
  function update(){ticking=false;var active=null;for(var i=0;i<map.length;i++){if(map[i].el.getBoundingClientRect().top-OFFSET<=0){active=map[i];}}if(!active&&map.length){active=map[0];}links.forEach(function(a){a.classList.remove("is-active");a.removeAttribute("aria-current");});if(active){active.a.classList.add("is-active");active.a.setAttribute("aria-current","true");}}
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener("scroll",onScroll,{passive:true});
  window.addEventListener("resize",onScroll,{passive:true});
  links.forEach(function(a){a.addEventListener("click",function(){if(window.matchMedia("(max-width: 1023px)").matches){toc.removeAttribute("open");}});});
  update();
})();

/* SUMMARISE WITH AI: toolbar appended to the hero (header), above the TOC */
(function(){
  "use strict";
  var hero=document.querySelector(".itx .hero .hero__inner")||document.querySelector(".itx .hero");
  if(!hero||document.querySelector(".itx-ai"))return;
  var h1=document.querySelector(".itx .hero h1");
  var title=h1?h1.textContent.replace(/\s+/g," ").trim():document.title;
  var url=location.href.split("#")[0];
  var p=encodeURIComponent("Summarise this article and give me the key takeaways: "+title+" "+url);
  var L=window.ITX_AI_LOGOS||{};
  var tools=[["ChatGPT","https://chatgpt.com/?q="+p,L.chatgpt],["Claude","https://claude.ai/new?q="+p,L.claude],["Gemini","https://gemini.google.com/app?q="+p,L.gemini]];
  var html='<span class="itx-ai__label">Summarise this article</span><div class="itx-ai__btns">';
  for(var i=0;i<tools.length;i++){var ico=tools[i][2]?'<img class="itx-ai__ico" src="'+tools[i][2]+'" alt="" aria-hidden="true">':'';html+='<a href="'+tools[i][1]+'" target="_blank" rel="noopener nofollow">'+ico+'<span>'+tools[i][0]+'</span></a>';}
  html+='</div>';
  var box=document.createElement("div");
  box.className="itx-ai";
  box.innerHTML=html;
  hero.appendChild(box);
})();

/* LEARN PRODUCT ROUTES: learn_product_click for the block beside the tools (snippets/learn-product-fit.liquid) */
(function(){
  "use strict";
  document.addEventListener("click",function(e){
    var a=e.target.closest&&e.target.closest("[data-learn-fit]");if(!a)return;
    var b=a.getAttribute("data-learn-fit").split("|"),d={article:b[0]||"",product:b[1]||"",action:b[2]||""};
    try{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event:"learn_product_click"},d));}catch(x){}
    try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish("learn_product_click",d);}catch(x){}
    try{if(typeof window.clarity==="function")window.clarity("event","learn_product_click");}catch(x){}
  },true);
})();
